/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Button, FullscreenDialog, Typography, Typography2, breakpoints } from '@coursera/cds-core';

import _t from 'i18n!nls/degree-home';

import CheckIcon from './images/check-icon.svg';

type NoEnrollmentRequiredViewProps = {
  onClose: () => void;
  headingText?: string;
  bodyText?: string;
};

const styles = {
  container: () => css`
    padding-top: var(--cds-spacing-1400);
    overflow-y: auto;

    ${breakpoints.down('sm')} {
      padding-top: var(--cds-spacing-400);
    }
  `,
  icon: () => css`
    width: 70px;
    margin-bottom: var(--cds-spacing-400);
  `,
  pageTitle: () => css`
    margin-bottom: var(--cds-spacing-100);
  `,
};

export const NoEnrollmentRequiredView = ({ onClose, headingText, bodyText }: NoEnrollmentRequiredViewProps) => {
  const { Content, Actions } = FullscreenDialog;
  return (
    <>
      <Content id="enrollmentDialogContent" aria-live="polite" aria-atomic="true">
        <div css={styles.container}>
          <img css={styles.icon} src={CheckIcon} alt={_t(`Checkmark icon`)} />
          <Typography component="h1" variant="h1semibold" css={styles.pageTitle}>
            {headingText ?? _t(`Nothing to do here! Looks like you've already enrolled into this course.`)}
          </Typography>
          <Typography2 component="p" variant="bodyPrimary">
            {bodyText ?? _t('Go back to the degree home page to continue learning.')}
          </Typography2>
        </div>
      </Content>
      <Actions>
        <Button variant="secondary" onClick={onClose}>
          {_t('Go back home')}
        </Button>
      </Actions>
    </>
  );
};

export default NoEnrollmentRequiredView;
